<script>
    import StarRating from './StarRating.svelte';
    export let partner = {};
    export let ctaText = "";
    export let ctaColor = "";
    export let ctaTextColor = "fff";
    export let partnerRowBackgroundColor = "fff";
    export let displayStarRating = true;

    function mutateImgSrc(src) {
        if (src.includes('api-domain-compado')) {
            const url = src.split('?')[0];
            return url + '?d=200x200&q=80'
        }

        return src;
    }

    function mutatePartnerName(name) {
        return name.replace(/-/g, ' ').toLowerCase();
    }
</script>

<a class="" rel="sponsored nofollow noreferrer" href="{partner['clickout_link']}"  target="_blank"  style="--primary: {ctaColor}">
    <div class="flex rounded-lg shadow-lg p-0 mb-1.5 overflow-hidden" style="background-color: #{partnerRowBackgroundColor};">
        <div class="h-[100px] w-1/4" style="clip-path: polygon(0 0, 100% 0, 90% 100%, 0% 100%);">
            <img
                    class="h-full w-full object-cover"
                    src="{mutateImgSrc(partner['logo_src'])}"
                    width="160"
                    height="100"
                    alt="{partner['name']}"
            >
        </div>

        <div class="flex flex-col w-full px-3 py-2 justify-between w-3/4">
            {#if partner['name']}
                <div class="font-bold capitalize">{mutatePartnerName(partner['name'])}</div>
            {/if}

            <div class="flex items-center">
                <span class="mr-2 font-bold">{partner['score']}</span>

                {#if displayStarRating}
                    <StarRating
                            iconWidth="20"
                            score="{partner['score']}"
                    />
                {/if}
            </div>

            <button
                    style="background-color: #{ctaColor}; color: #{ctaTextColor};"
                    class="flex items-center justify-center rounded-md text-white h-7 text-sm"
                    type="button"
            >
                {ctaText}
            </button>
        </div>
    </div>
</a>